import React from "react";
import I18n from "@infrastructure/i18n";

// Used from Rails mounts with:
// data: { react_suspense_fallback: "<fallback_key>" }
// Unknown keys safely fall back to "default".
export const DEFAULT_SUSPENSE_FALLBACK_KEY = "default";
export const NONE_SUSPENSE_FALLBACK_KEY = "none";

const DefaultLoadingFallback = () => (
  <div>{I18n?.t?.("admin.general.loading")}</div>
);

type LoadingFallback = () => React.ReactNode;

const SUSPENSE_FALLBACK_REGISTRY: Record<string, LoadingFallback> = {
  [DEFAULT_SUSPENSE_FALLBACK_KEY]: () => <DefaultLoadingFallback />,
  [NONE_SUSPENSE_FALLBACK_KEY]: () => null,
};

// To add a new root fallback:
// 1) Create a lightweight fallback component.
// 2) Add a new "<key>" constant.
// 3) Register the key in SUSPENSE_FALLBACK_REGISTRY.
export const resolveSuspenseFallback = (
  key?: string | null,
): React.ReactNode => {
  const fallbackKey = key || DEFAULT_SUSPENSE_FALLBACK_KEY;

  if (SUSPENSE_FALLBACK_REGISTRY[fallbackKey]) {
    return SUSPENSE_FALLBACK_REGISTRY[fallbackKey]();
  }

  return SUSPENSE_FALLBACK_REGISTRY[DEFAULT_SUSPENSE_FALLBACK_KEY]();
};
